import { Header, Paragraph } from '@eggplant/pattern-library'

const MonitorPerformanceDashboard = () =>
  <div className='grid gap-3'>
    <Header
      hasNoBottomMargin
      hasNoTopMargin
      rank={5}
    >
      Monitor Performance
    </Header>
    <Paragraph>
      This page breaks down the test cases in your selected monitor configuration, showing the run time data of it's test case steps over a specified period.
    </Paragraph>
  </div>

export default MonitorPerformanceDashboard
